import { Component, Input, OnInit } from '@angular/core';
import { FlujoVentaPasoAutorizacion } from '../../../_models/flujo-venta-paso-autorizacion';
import { FlujoVentaPasoAutorizacionService } from '../../../_services/flujo-venta-paso-autorizacion.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FlujoVentaPaso } from '../../../_models/flujo-venta-paso';
import { NavService } from '../../../_services/_nav.service';
import { ListaService } from '../../../_services/lista.service';
import { PlantillaService } from '../../../_services/plantilla.service';
import { ListaItem } from '../../../_models/lista-item';
import { Plantilla } from '../../../_models/plantilla';
import {forkJoin} from "rxjs";
import {
  FlujoVentaPasoAutorizacionTipoProductoBancarioService
} from "../../../_services/flujo-venta-paso-autorizacion-tipo-producto-bancario.service";
import {
  FlujoVentaPasoAutorizacionTipoProductoBancario
} from "../../../_models/flujo-venta-paso-autorizacion-tipo-producto-bancario";

@Component( {
  selector: 'app-flujo-venta-plantilla',
  templateUrl: 'flujo-venta-plantilla.component.html'
} )

export class FlujoVentaPlantillaComponent implements OnInit {

  @Input() fluVentaPaso: FlujoVentaPaso;
  @Input() lisAutorizaciones: ListaItem[] = [];
  @Input() lisPlantilla: Plantilla[] = [];
  @Input() lisFases: ListaItem[] = [];
  @Input() listasTiposProductosBancarios: SelectItem[] = [];
  cargando = true;
  lisFlujoAutorizacionTodos: FlujoVentaPasoAutorizacion[] = [];
  lisFlujoAutorizacion: FlujoVentaPasoAutorizacion[] = [];
  formulario: FormGroup;
  submitted = false;
  columnas: any[] = [];
  lisAutorizacionSelect: SelectItem[] = [];
  lisFasesSelect: SelectItem[] = [];
  lisPlantillaSelect: SelectItem[] = [];
  listTipoProceso: FlujoVentaPasoAutorizacionTipoProductoBancario[] = [];
  invalidDependentFields = false;


  constructor( private fluVentaPasoAutorizacionService: FlujoVentaPasoAutorizacionService,
               private navService: NavService,
               private lisService: ListaService,
               private plaService: PlantillaService,
               private conService: ConfirmationService,
               private fb: FormBuilder,
               private flujoVentaPasoAutorizacionTipoProductoBancarioService: FlujoVentaPasoAutorizacionTipoProductoBancarioService) {
  }

  ngOnInit(): void {
    this.lisFasesSelect = this.lisFases.map( s => ( { label: s.nombre, value: s.idLista } ) );
    this.columnas = [
      { field: 'autorizacion', header: this.navService.buscarMensaje( 'FLUJOVENTAAUTORIZACIONES.LBL_AUTORIZACION' ), sort: false },
      { field: 'descripcion', header: this.navService.buscarMensaje( 'FLUJOVENTAAUTORIZACIONES.LBL_DESCRIPCION' ), sort: false },
      { field: 'plantilla', header: this.navService.buscarMensaje( 'FLUJOVENTAAUTORIZACIONES.LBL_PLANTILLA' ), sort: false },
      { field: 'fase', header: this.navService.buscarMensaje( 'FLUJOVENTAAUTORIZACIONES.LBL_FASE' ), sort: false },
      { field: "indicadorRequeridaInicio", header: this.navService.buscarMensaje(  "FLUJOVENTAAUTORIZACIONES.LBL_REQUERIDAALINICIO"), sort: false },
      { field: 'tipoProceso', header: this.navService.buscarMensaje( 'FLUJOVENTAAUTORIZACIONES.LBL_TIPODEPRODUCTO' ), sort: false },
      { field: 'det', header: this.navService.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    this.fluVentaPasoAutorizacionService.listadoPorIdFlujoVentaPaso( this.fluVentaPaso.idFlujoVentaPaso ).subscribe( lisFlujoPlantillas => {
      this.lisFlujoAutorizacionTodos = lisFlujoPlantillas;
      const consultas: any[] = [];
      lisFlujoPlantillas.map(e => {
        consultas.push(this.flujoVentaPasoAutorizacionTipoProductoBancarioService.obtenerPorIdFlujoVentaPasoAutorizacion(e.idFlujoVentaPasoAutorizacion));
      });
      if (consultas.length > 0) {
        forkJoin(consultas).subscribe(r => {
          lisFlujoPlantillas.forEach(flujoPlantilla => {
            const lisTipoProceso = r.flatMap((e: FlujoVentaPasoAutorizacionTipoProductoBancario[]) =>
              e.filter(h => h.idFlujoVentaPasoAutorizacion === flujoPlantilla.idFlujoVentaPasoAutorizacion)
            );
            if (lisTipoProceso.length > 0) {
              flujoPlantilla.tipoProceso = lisTipoProceso.map(f => f.tipoProducto).join(', ');
              flujoPlantilla.lisTipoProceso = lisTipoProceso;
            }
          });
          this.finalizarCarque();
        }, error => {
          this.finalizarCarque();
        })
      } else {
        this.finalizarCarque();
      }
    } );
  }

  finalizarCarque() {
    this.cargarListado();
    this.cargarAutorizaciones();
    this.cargarPlantillas();
    this.cargarFormulario();
    this.cargando = false;
  }

  cargarAutorizaciones() {
    this.lisAutorizacionSelect = [];
    this.lisAutorizaciones.forEach( e => {
      if ( !this.lisFlujoAutorizacion.find( x => x.idAutorizacion === e.idLista ) ) {
        this.lisAutorizacionSelect.push( { label: e.nombre, value: e.idLista } );
      }
    } );
  }

  cargarPlantillas() {
    this.lisPlantillaSelect = [];
    this.lisPlantilla.forEach( e => {
      if ( !this.lisFlujoAutorizacion.find( x => x.idPlantilla === e.idPlantilla ) ) {
        this.lisPlantillaSelect.push( { label: e.nombre, value: e.idPlantilla } );
      }
    } );
  }

  actualizarTipoProceso(registro: FlujoVentaPasoAutorizacion) {
    const actualizar: FlujoVentaPasoAutorizacionTipoProductoBancario[] = [];
    const listaTipoProceso = this.f.tipoProceso.value;
    if (registro.lisTipoProceso && registro.lisTipoProceso.length > 0) {
      registro.lisTipoProceso.forEach(e => {
        e.indicadorHabilitado = !!listaTipoProceso.find(x => x === e.idTipoProductoBancario) && registro.indicadorHabilitado;
        actualizar.push(e);
      });
    }
    if (listaTipoProceso.length > 0) {
      listaTipoProceso.forEach(idTipoProductoBancario => {
        if (!actualizar.find(a => a.idTipoProductoBancario === idTipoProductoBancario)) {
          const objeto = {} as FlujoVentaPasoAutorizacionTipoProductoBancario;
          objeto.idFlujoVentaPasoAutorizacion = registro.idFlujoVentaPasoAutorizacion;
          objeto.idTipoProductoBancario = idTipoProductoBancario;
          objeto.indicadorHabilitado = true;
          actualizar.push(objeto);
        }
      });
    }
    if (actualizar.length > 0) {
      this.flujoVentaPasoAutorizacionTipoProductoBancarioService.bulk(actualizar).subscribe(r => {
        const lisTipoProceso = r.filter(x => x.indicadorHabilitado);
        if (lisTipoProceso.length > 0) {
          const index = this.lisFlujoAutorizacion.findIndex(s => s.idFlujoVentaPasoAutorizacion === registro.idFlujoVentaPasoAutorizacion);
          if (index > -1) {
            this.lisFlujoAutorizacion[index].tipoProceso = this.listasTiposProductosBancarios.filter(x => lisTipoProceso.find(tp => tp.idTipoProductoBancario === x.value)).map(x => x.label).join(', ');
            this.lisFlujoAutorizacion[index].lisTipoProceso = lisTipoProceso;
          }
        }
      });
    }
  }

  onSubmit() {
    this.submitted = true;

    if ( !this.formulario.valid ) {
      return;
    }

    this.cargando = true;
    const registro = this.formulario.value;
    const existe = this.lisFlujoAutorizacionTodos.find( x => x.idAutorizacion === registro.idAutorizacion );
    if ( existe && !existe.indicadorHabilitado ) {
      /* existe.indicadorHabilitado = true; */
      existe.idPlantilla = registro.idPlantilla;
      existe.idFase = registro.idFase;
      existe.indicadorHabilitado = registro.indicadorHabilitado;
      existe.indicadorRequeridaInicio = registro.indicadorRequeridaInicio;
      existe.descripcion = registro.descripcion;
      existe.descripcion = registro.descripcion !== null ? registro.descripcion.trim(): null;
      if (existe.descripcion === "") {
        existe.descripcion = null;
      }
      this.fluVentaPasoAutorizacionService.actualizar( existe ).subscribe( r => {
        r.lisTipoProceso = existe.lisTipoProceso;
        this.actualizarTipoProceso(r);
        this.asignarCampos( existe );
        this.salirGuardar();
      } );
    } else if ( !existe ) {
      /* registro.indicadorHabilitado = true; */
      const autorizacion = this.lisAutorizacionSelect.find( x => x.value === registro.idAutorizacion );
      registro.autorizacion = autorizacion ? autorizacion.label : null;
      this.asignarCampos( registro );
      registro.descripcion = registro.descripcion !== null ? registro.descripcion.trim(): null;
      if (registro.descripcion === "") {
        registro.descripcion = null;
      }
      this.fluVentaPasoAutorizacionService.crear( registro ).subscribe( r => {
        this.actualizarTipoProceso(r);
        registro.idFlujoVentaPasoAutorizacion = r.idFlujoVentaPasoAutorizacion;
        this.lisFlujoAutorizacionTodos.push( registro );
        this.salirGuardar();
      } );
    } else {
      this.navService.setMesage( 0, {
        severity: 'info', summary: this.navService.buscarMensaje( 'LBL_ATENCION' ),
        detail: this.navService.buscarMensaje( 'MSG_YAEXISTEELREGISTRO' )
      } );
      this.cargando = false;
    }
  }

  asignarCampos( registro: FlujoVentaPasoAutorizacion ) {
    const plantilla = this.lisPlantillaSelect.find( x => x.value === registro.idPlantilla );
    registro.plantilla = plantilla ? plantilla.label : null;
    const fase = this.lisFasesSelect.find( x => x.value === registro.idFase );
    registro.fase = fase ? fase.label : null;
  }

  salirGuardar() {
    this.cargarListado();
    this.cargarAutorizaciones();
    this.cargarPlantillas();
    this.navService.setMesage( 1 );
    this.submitted = false;
    this.cargarFormulario();
    this.formulario.markAsPristine();
    this.cargando = false;
  }

  get f() {
    return this.formulario.controls;
  }

  cargarFormulario() {
    this.formulario = this.fb.group( {
      idFlujoVentaPaso: [ this.fluVentaPaso.idFlujoVentaPaso, [ Validators.required ] ],
      idPlantilla: [ null, [ Validators.required ] ],
      descripcion: [ null ],
      tipoProceso: [ [], [ Validators.required ] ],
      idFase: [ null, [ Validators.required ] ],
      idAutorizacion: [ null, [ Validators.required ] ],
      indicadorRequeridaInicio: [false],
      indicadorHabilitado: [ true ],
    } );
  }

  cargarListado() {
    this.lisFlujoAutorizacion = this.lisFlujoAutorizacionTodos.filter( x => x.indicadorHabilitado );
  }

  inhablitar( registro: FlujoVentaPasoAutorizacion ) {
    this.conService.confirm( {
      message: this.navService.buscarMensaje( 'MSG_INHABILITAR' ),
      header: this.navService.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      key: `flujoVentaAutorizacion${ this.fluVentaPaso.codigo }`,
      accept: () => {
        this.cargando = true;
        registro.indicadorHabilitado = false;
        this.fluVentaPasoAutorizacionService.actualizar( registro ).subscribe( r => {
          this.actualizarTipoProceso(registro);
          this.navService.setMesage( 2 );
          this.cargarListado();
          this.cargarAutorizaciones();
          this.cargarPlantillas();
          this.cargando = false;
        } );
      }
    } );
  }

}
